export const NoDataMessage = 'No information was found for this request.';

export const MemberBlocked = 'MEMBER BLOCKED';

export const ToolsHeading = 'Tools';
